import { i18n } from '@/lang';

export const timeConversion = (time, type, startTip, endTip, centerTip) => { // 时间转换器  time单位为秒  type 例如 yyyymmddhhmmss
  const date = new Date(time * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  const mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  const ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

  let types = type;
  types = String(types).toLowerCase();
  switch (types) {
    case 'yyyymmddhhmmss' : // 年月日时分秒
      return `${year}${startTip}${month}${startTip}${day}${centerTip || ' '}${hh}${endTip}${mm}${endTip}${ss}`;
    case 'yyyymmdd' : // 年月日
      return `${year}${startTip}${month}${startTip}${day}`;
    case 'mmdd' : // 月日
      return `${month}${startTip}${day}`;
    case 'hhmmss' : // 时分秒
      return `${hh}${endTip}${mm}${endTip}${ss}`;
    case 'yyyy-mm-dd hh:mm:ss' :
      return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
    case 'yyyy-mm-dd' :
      return `${year}-${month}-${day}`;
    case 'yyyy/mm/dd' :
      return `${year}/${month}/${day}`;
    case 'mm-dd' :
      return `${month}-${day}`;
    case 'mm-dd hh:mm:ss' :
      return `${month}-${day} ${hh}:${mm}:${ss}`;
    case 'hh:mm' :
      return `${hh}:${mm}`;
    case 'hh:mm:ss' :
      return `${hh}:${mm}:${ss}`;
    case 'mm-dd hh:mm' :
      return `${month}-${day} ${hh}:${mm}`;
    default :
      return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
  }
};

// 获取年月日的秒数
export const getSeconds = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return parseInt(new Date(`${year}/${month}/${day}`).getTime() / 1000);
};

// 获取剩余时间
export const getRemainingTime = (t1) => {
  // 获取当前时间
  const date = new Date();
  const now = date.getTime();
  // 设置截止时间
  // const str = '2017/5/17 00:00:00';
  const endDate = new Date(t1);
  const end = endDate.getTime();

  // 时间差
  const leftTime = end - now;
  // 定义变量 d,h,m,s保存倒计时的时间
  let h = '00'; let m = '00'; let s = '00';
  if (leftTime >= 0) {
    // d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor(leftTime / 1000 / 60 / 60);
    h = h < 10 ? '0' + h : h;
    m = Math.floor(leftTime / 1000 / 60 % 60);
    m = m < 10 ? '0' + m : m;
    s = Math.floor(leftTime / 1000 % 60);
    s = s < 10 ? '0' + s : s;
  }

  return `${h}:${m}:${s}`;
};

export const isPc = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'
  ];
  let flag = true;
  for (let i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) !== -1) {
      flag = false;
      break;
    }
  }
  return flag;
};

// 获取地址栏url参数 如www.baidu.com/?token='88888' getQueryString('token') // 88888
export const getQueryString = (name, url = window.location.href) => {
  const search = decodeURIComponent(url).split('?')[1] || '';
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = search.match(reg);
  let context = '';
  if (r != null) context = r[2];
  reg = null;
  r = null;
  // eslint-disable-next-line
  return context == null || context == '' || context == 'undefined' ? '' : context;
};

export const formatMoney = (num) => {
  num = num.replace(/,/g, '');
  if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
    return num;
  }
  const a = RegExp.$1; let b = RegExp.$2; const c = RegExp.$3;

  const re = new RegExp().compile('(\\d)(\\d{3})(,|$)');
  while (re.test(b)) b = b.replace(re, '$1,$2$3');
  return a + '' + b + '' + c;
};

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export const parseTime = (time, cFormat) => {
  if (!time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(/-/gm, '/');
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value]; }
    return value.toString().padStart(2, '0');
  });
  return timeStr;
};

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */

export const formatTime = (time, option) => {
  const locale = i18n.locale;
  const messages = i18n.messages;
  const lang = messages[locale];

  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return lang.just;
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + lang.minsAgo;
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + lang.hoursAgo;
  } else if (diff < 3600 * 24 * 2 * 30) {
    return Math.ceil(diff / (3600 * 24)) + lang.daysAgo;
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      lang.month +
      d.getDate() +
      lang.cDay +
      d.getHours() +
      lang.hour +
      d.getMinutes() +
      lang.minute
    );
  }
};

export const formatSeconds = (value) => {
  let theTime = parseInt(value);// 秒
  let theTime1 = 0;// 分
  let theTime2 = 0;// 小时
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
    }
  }
  let result = '' + parseInt(theTime) + 's';
  if (theTime1 > 0) {
    result = '' + parseInt(theTime1) + 'm ' + result;
  }
  if (theTime2 > 0) {
    result = '' + parseInt(theTime2) + 'h ' + result;
  }
  return result;
};

const ua = navigator.userAgent.toLowerCase();

export const isSafari = () => {
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    return true;
  } else {
    return false;
  }
};

export const isAndroid = () => {
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; // android终端
};

export const isIos = () => {
  return !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/); // ios终端
};

export const getBrowserLang = () => {
  const browserLang = window.navigator.language;
  let lang = 'USA';

  if (browserLang.includes('vi')) {
    lang = 'VNM';
  }

  if (browserLang.includes('zh')) {
    lang = 'TC';
  }

  if (browserLang.includes('en')) {
    lang = 'USA';
  }
  return lang;
};
